import { render, staticRenderFns } from "./DashboardOrderList.vue?vue&type=template&id=93cf69a0&"
import script from "./DashboardOrderList.vue?vue&type=script&lang=ts&"
export * from "./DashboardOrderList.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardOrderList.vue?vue&type=style&index=0&id=93cf69a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports